import { render, staticRenderFns } from "./ModalAddPatient.vue?vue&type=template&id=0906b91d&scoped=true"
import script from "./ModalAddPatient.vue?vue&type=script&lang=js"
export * from "./ModalAddPatient.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPatient.vue?vue&type=style&index=0&id=0906b91d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0906b91d",
  null
  
)

export default component.exports